import config from "../../../config/config";
import * as api from "./checkout.api";
import * as mocks from "./checkout.mocks";
import {
  CreateOrderResponse,
  ApplyVoucherResponse,
  UpdateCustomerInfoRequest,
  UpdateCustomerInfoResponse,
  CommitOrderRequest,
  CommitOrderResponse,
  GetOrderResponse,
  PaymentMethodDescriptor,
  PaymentProvider,
  PaymentMethod,
  CardPaymentFormData,
  ProcessCardPaymentResponse,
} from "./checkout.interfaces";

export const createOrder = async (packageId: string): Promise<CreateOrderResponse> => {
  if (config.useRealApi) {
    return await api.apiCreateOrder({ packageId });
  }
  return await mocks.createOrder(packageId);
};

export const applyVoucher = async (
  orderId: string,
  voucherCode: string
): Promise<ApplyVoucherResponse> => {
  if (config.useRealApi) {
    return await api.apiApplyVoucher({ orderId, voucherCode });
  }
  return await mocks.applyVoucher({ orderId, voucherCode });
};

export const updateCustomerInfo = async (
  orderId: string,
  customerInfo: UpdateCustomerInfoRequest["customerInfo"]
): Promise<UpdateCustomerInfoResponse> => {
  if (config.useRealApi) {
    return await api.apiUpdateCustomerInfo({ orderId, customerInfo });
  }
  return await mocks.updateCustomerInfo({ orderId, customerInfo });
};

export const getPaymentMethods = async (): Promise<PaymentMethodDescriptor[]> => {
  if (config.useRealApi) {
    return await api.apiGetPaymentMethods();
  }
  return mocks.getPaymentMethods();
};

export const getOrder = async (orderId: string): Promise<GetOrderResponse> => {
  if (config.useRealApi) {
    return await api.apiGetOrder(orderId);
  }
  return await mocks.getOrder(orderId);
};

export const commitOrder = async (
  orderId: string,
  provider: PaymentProvider,
  method: PaymentMethod
): Promise<CommitOrderResponse> => {
  const request: CommitOrderRequest = { orderId, provider, method };
  if (config.useRealApi) {
    return await api.apiCommitOrder(request);
  }
  return await mocks.commitOrder(request);
};

export const processCardPayment = async (
  orderId: string,
  form: CardPaymentFormData
): Promise<ProcessCardPaymentResponse> => {
  if (config.useRealApi) {
    return await api.apiProcessCardPayment(orderId, form);
  }
  return {
    success: true,
    message: "Pagamento simulado (mock)",
    orderStatus: "Paid",
    paymentStatus: "Captured",
    providerPaymentId: `mp_mock_${orderId}`,
  };
};
